import { Component, Input, ViewChild, } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseModalWithProfilePhotoComponent } from '../base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AddressComponent } from '../../address/address.component';
import { AddressModel } from 'src/app/core/models/address.model';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss']
})
export class ContactModalComponent extends BaseModalWithProfilePhotoComponent {

  emailPattern = GlobalComponent.emailPattern;

  securityPermissionAccountDelete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountDelete);
  securityPermissionAccountUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountUpdate);
  securityPermissionAccountCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountCreate);

  @Input() public override model: ContactModel = new ContactModel;
  @Input() public entityTypeId: EntityTypeEnum = EntityTypeEnum.Account;
  @Input() public disableInputs: boolean = false; 
  @ViewChild('addressComponent') addressComponent!: AddressComponent;

  constructor(
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  ngOnInit(): void {
    if (this.model.id === undefined) {
      this.newModel = true;
    } else {

      this.loadProfilePhoto(this.model.id,  this.entityTypeId,this.model.profilePhotoFileId, this.model.fullName);
      
    }
  }

  ngOnDestroy(): void {
    this.model = new ContactModel;
  }

  onUpdate(): void {
    this.disableEditing = true;
    this.myFileApiService.updateContact(this.model).subscribe(
      (result: boolean | undefined) => {
        if (result) {
          this.toasterNotificationService.showSuccess($localize`:@@ContactPopUp_Toast_Success_UpdateContact:Your contact has been updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        this.submitted = false;
        this.disableEditing = false;
        this.close();
      }
    )
  }

  onCreate(): void {
    this.disableEditing = true;
    this.myFileApiService.createContact(this.model).subscribe(
      (result: ContactModel | undefined) => {
        if (result) {
          this.model = result;
          this.toasterNotificationService.showSuccess($localize`:@@ContactPopUp_Toast_Success_CreateContact:Your new contact has been created.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        this.submitted = false;
        this.disableEditing = false;
        this.close();
      }
    )
  }

  validate() {
    if (AddressModel.validateAddressModel(this.model.address)) {
      if ((this.model.companyName && this.model.companyName.length > 0) || (this.model.firstName && this.model.firstName.length > 0)) {
        if (this.model.phoneNumber != undefined && (this.model.phoneNumber.length == 14 || this.model.phoneNumber == "")) {
          if (this.model.faxNumber != undefined && (this.model.faxNumber.length == 14 || this.model.faxNumber == "")) {
            if (this.model.email != undefined && (this.emailPattern.test(this.model.email) || this.model.email == '')) {
              if (this.model.phoneNumber == "" && this.model.email == "" && this.model.faxNumber == "") {
                this.activeTab = 1;
              } else {
                return true;
              }
            }
          }
        }
      } else {
        this.activeTab = 1;
      }
    } else {
      this.activeTab = 2;
    }

    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

}
